import React from "react";

const SkeletonInput = ({ labelWidth = "120px", className = "" }) => (
  <div className={`skeleton-input ${className}`}>
    <div
      className="skeleton-label mb-2"
      style={{
        width: labelWidth,
        height: "16px",
        background: "#f0f0f0",
        borderRadius: "4px",
      }}
    ></div>
    <div
      className="skeleton-field"
      style={{
        width: "100%",
        height: "40px",
        background: "#f0f0f0",
        borderRadius: "6px",
      }}
    ></div>
  </div>
);

const SkeletonDayButtons = () => (
  <div className="skeleton-days">
    <div
      className="skeleton-label mb-3"
      style={{
        width: "200px",
        height: "16px",
        background: "#f0f0f0",
        borderRadius: "4px",
      }}
    ></div>
    <div className="d-flex flex-wrap gap-2">
      {[1, 2, 3, 4, 5, 6].map((item) => (
        <div
          key={item}
          className="skeleton-day-button"
          style={{
            width: "110px",
            height: "42px",
            background: "#f0f0f0",
            borderRadius: "8px",
          }}
        ></div>
      ))}
    </div>
  </div>
);

const AddScheduleSkelton = () => {
  return (
    <div className="form-skeleton">
      <div className="row mb-4">
        <div className="col-md-6 col-lg-4 mb-3">
          <SkeletonInput labelWidth="120px" />
        </div>
        <div className="col-md-6 col-lg-4 mb-3">
          <SkeletonInput labelWidth="120px" />
        </div>
        <div className="col-md-6 col-lg-4 mb-3">
          <SkeletonInput labelWidth="120px" />
        </div>

        <div className="col-md-6 col-lg-4 mb-3">
          <SkeletonInput labelWidth="120px" />
        </div>
        <div className="col-md-6 col-lg-4 mb-3">
          <SkeletonInput labelWidth="120px" />
        </div>
        <div className="col-md-6 col-lg-4 mb-3">
          <SkeletonInput labelWidth="120px" />
        </div>
      </div>

      <div className="mb-4">
        <SkeletonDayButtons />
      </div>

      <div className="mb-4">
        <div
          className="skeleton-label mb-2"
          style={{
            width: "150px",
            height: "16px",
            background: "#f0f0f0",
            borderRadius: "4px",
          }}
        ></div>
        <div
          className="skeleton-field"
          style={{
            width: "100%",
            height: "120px",
            background: "#f0f0f0",
            borderRadius: "6px",
          }}
        ></div>
      </div>

      {/* Button Skeletons */}
      <div className="pt-4 mt-3 border-top text-end">
        <div
          className="skeleton-button d-inline-block me-3"
          style={{
            width: "100px",
            height: "40px",
            background: "#f0f0f0",
            borderRadius: "4px",
          }}
        ></div>
        <div
          className="skeleton-button d-inline-block"
          style={{
            width: "100px",
            height: "40px",
            background: "#f0f0f0",
            borderRadius: "4px",
          }}
        ></div>
      </div>
    </div>
  );
};

export default AddScheduleSkelton;
